import React from 'react'
import Styled from 'styled-components'

const Container = Styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => props.maxWidth ? props.maxWidth : "100%"};
  align-self: flex-end;
  `
  
  const ButtonContainer = Styled.div`
  display: flex;
  align-self: flex-end;
`

const BottomButtonContainer = ({ children, maxWidth }) => {
  return (
    <Container maxWidth={maxWidth}>
      <ButtonContainer>
      {children}
      </ButtonContainer>
    </Container>
  )
}

export default BottomButtonContainer
